import React from "react";
import "./PasswordUpdatedModal.css";

const PasswordUpdatedModal = ({ isOpen, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div className="password-updated-modal-overlay">
      <div className="password-updated-modal">
        <div className="password-updated-icon">✅</div>
        <h2 className="password-updated-title">
          Password Updated Successfully!
        </h2>
        <p className="password-updated-message">
          You can now log in with your new password.
        </p>
        <button className="password-updated-btn" onClick={onContinue}>
          Continue to Login
        </button>
      </div>
    </div>
  );
};

export default PasswordUpdatedModal;
